<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" :class="{ disable: formType === 0 ? true : false }">
      <a-form-model-item label="举报人" prop="nickname">
        <a-input readOnly v-model="form.nickname" placeholder="请输入举报人" />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status">
        <a-radio-group v-model="form.status">
          <!-- <a-radio :value="0">未审核</a-radio> -->
          <a-radio :value="1">通过</a-radio>
          <a-radio :value="2">驳回</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="被举报动态标题" prop="content">
        <a-input  type="textarea" v-model="form.content" placeholder="请输入被举报动态标题" />
      </a-form-model-item>
   
      <a-form-model-item label="图片" prop="linkAddress" v-if="form.imageVideo == 1">
        <img
          v-viewer
          style="width: 48px; height: 48px; margin-top: 5px; margin-right: 5px"
          v-for="item in form.linkAddressImg"
          :src="item"
          preview="头像"
        />
      </a-form-model-item>
      <a-form-model-item label="视频"  prop="linkAddress" v-if="form.imageVideo == 2">
        <video
          style="width: 180px; height: 120px"
          class="avatar video-avatar"
          controls="controls"
          :src="form.linkAddress"
        />
      </a-form-model-item>
      <a-form-model-item label="分类" prop="category" v-if="form.category">
        <a-input readOnly v-model="form.categoryStr" />
      </a-form-model-item>
      <a-form-model-item label="话题" prop="talk" v-if="form.talk">
        <a-input readOnly v-model="form.talkStr" />
      </a-form-model-item>
      <a-form-model-item label="举报原因" prop="reason">
        <a-input readOnly v-model="form.reason" placeholder="暂无" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="补充说明" prop="otherReason">
        <a-input readOnly v-model="form.otherReason" placeholder="暂无" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="驳回原因" prop="rejectReason" v-if="form.status == 2">
        <a-input v-model="form.rejectReason" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDynamicReport, addDynamicReport, updateDynamicReport } from '@/api/dynamic/dynamicReport'
import { getInfo } from '@/api/dynamics/info'

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,
        nickname: null,
        status: "",
        content: '',
        dynamicId: null,

        reason: null,
        linkAddressImg:[],

        otherReason: null,

        rejectReason: null,

        createTime: null,

        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        status: [{ required: true, message: '状态不能为空', trigger: 'blur' }],
        rejectReason: [{ required: true, message: '驳回原因不能为空', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {},
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        nickname: null,
        status: "",
        dynamicId: null,
        reason: null,
        content: '',
        otherReason: null,
        rejectReason: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.open = true
      this.formTitle = '添加'
      this.reset()
      this.formType = 1
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.open = true
      this.formTitle = '审核'
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDynamicReport({ id: id }).then((response) => {
        this.form = response.data
        this.form.content = this.form.content == null ? '' : this.form.content
        console.log(this.form, 'form')
      })
      getInfo({ id: row.dynamicId }).then((response) => {
        this.form.linkAddress=response.data.linkAddress,
        this.form.talk=response.data.talk,
        this.form.talkStr=response.data.talkStr,
        this.form.category=response.data.category,
        this.form.categoryStr=response.data.categoryStr,
        this.form.content=response.data.content,
     
        this.form.createTime=response.data.createTime,
        this.form.emoticonId=response.data.emoticonId,
        this.form.emotionIcon=response.data.emotionIcon,
        this.form.emotionStr=response.data.emotionStr,
        this.form.id=response.data.id,
        this.form.imageVideo=response.data.imageVideo,
        this.form.invisibleIds=response.data.invisibleIds,
        this.form.isDraft=response.data.isDraft,
        this.form.latitude=response.data.latitude,
        this.form.likeNum=response.data.likeNum,
        this.form.location=response.data.location,
        this.form.longitude=response.data.longitude,
        this.form.remark=response.data.remark,
        this.form.status=response.data.status==0?'':response.data.status,
    //  console.log(this.form.linkAddress.split(','),"this.form.linkAddress.split(',')")
        this.form.linkAddressImg = this.form.linkAddress.split(',')
       
        // this.form.transNum=response.data.transNum,
        // this.form.type=response.data.type,
        // this.form.visibleType=response.data.visibleType,

        console.log(this.form, 'form')
      })
    },
    handleWatch(row, ids) {
      this.reset()
      this.formType = 0
      const id = row ? row.id : ids
      getDynamicReport({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '详情'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateDynamicReport(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addDynamicReport(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style scoped>
.disable {
  pointer-events: none;
}
</style>
